import request from '@/api/request.js'

// 新增
export function QuestionDifficultyInsert(data) {
    return request({
        url: '/api/question/questiondifficultyinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function QuestionDifficultyDelete(id) {
    return request({
        url: `/api/question/questiondifficultydelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function QuestionDifficultyUpdate(id, data) {
    return request({
        url: `/api/question/questiondifficultyupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function QuestionDifficultyGetById(id) {
    return request({
        url: `/api/question/getquestiondifficultybyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function QuestionDifficultyGetList(params) {
    return request({
        url: '/api/question/getquestiondifficultylist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function QuestionDifficultyGetPageList(params) {
    return request({
        url: '/api/question/getquestiondifficultypagelist',
        method: 'get',
        params: params
    })
}